import { Icon, Link, MessageBar, MessageBarType, Spinner, SpinnerSize, Text } from "@fluentui/react";

import styles from "./DocumentViewer.module.css";

interface Props {
    blobUrl?: string;
    documentExt: string | "txt";
    pageNumber: string | number;
    error?: string;
};

export const DocumentViewer = ({ blobUrl, documentExt, pageNumber, error }: Props) => {
    const officeFormats = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
    const imageFormats = ['png', 'jpg', 'jpeg', 'gif'];

    // Render error message if there's an error
    if (error) {
        return <div className={styles.messageContainer}>
            <MessageBar
                messageBarType={MessageBarType.error}
                isMultiline={false}>
                Error: {error}
            </MessageBar>
        </div>;
    };

    const viewer = blobUrl === undefined ? (
        <Spinner size={SpinnerSize.large} label="Loading..." />
    ) : (documentExt === "pdf" ? (
        <object data={blobUrl + "#page=" + pageNumber} type="application/pdf" width="100%" height="760px" />
    ) : officeFormats.includes(documentExt) ? (
        <div className={styles.messageContainer}>
            <Icon iconName="Info" className={styles.icon} />
            <Text variant="large" block>
                Previewing Microsoft Office documents is currently not available within Coeus. To view this file, please{' '}
                <Link href={blobUrl} download>click here to download it</Link>.
            </Text>
            <Text variant="medium" block className={styles.messageText}>
                Coeus prefers PDF format, which can be viewed directly in your browser without the need to download.
            </Text>
        </div>
    ) : imageFormats.includes(documentExt) ? (
        <img src={blobUrl} className={styles.citationImg} />
    ) : (
        <iframe title="Source File" src={blobUrl} width="100%" height="760px" />
    ));

    return <div className={styles.docViewer}>{viewer}</div>;
};